import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import {
  deleteContributionReply,
  openEditContributionDialog
} from '../../../../../../../stores/discussion/discussion.actions'
import { errorHandler } from 'pobble-components/dist/error-handler'

const mapStateToProps = (state, { id, contributionId, parentId, content }) => {
  return {
    id: contributionId,
    parentId,
    body: content
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onDelete: () =>
    dispatch(
      deleteContributionReply(
        ownProps.contributionId,
        ownProps.id,
        ownProps.parentId
      )
    ).catch(errorHandler),
  onOpenEditContributionDialog: body =>
    dispatch(
      openEditContributionDialog(
        ownProps.contributionId,
        ownProps.id,
        body,
        ownProps.parentId
      )
    )
})

export default connect(
  mapStateToProps,
  mapDispatchToProps,
  mergeProps
)(ContextMenu)
